import { computed, ComputedRef, Ref } from 'vue';
import { Allocation } from '../Timeline.types';

/**
 * Groups allocations by their `locationId`. Each group is sorted by `startDateTime` ascending,
 * which the 'Compact' layout algorithm relies on.
 *
 * Shared by the section- and hierarchy-row builders so both derive location groupings the same way.
 */
export function useAllocationsByLocation(allocations: Ref<Allocation[]>): ComputedRef<Map<string, Allocation[]>> {
    return computed(() => {
        const result = new Map<string, Allocation[]>();

        for (const allocation of allocations.value) {
            const existing = result.get(allocation.locationId);
            if (existing) {
                existing.push(allocation);
            } else {
                result.set(allocation.locationId, [allocation]);
            }
        }

        for (const group of result.values()) {
            group.sort((a, b) => a.startDateTime.toMillis() - b.startDateTime.toMillis());
        }

        return result;
    });
}
